import { Paper, Stack, Text } from '@mantine/core'
import React from 'react'
import { useGetLandingPageJobsQuery } from '../redux/query/LandingPagesApi.slice'
import ErrorLoading from '../../../react/core/ErrorLoading'
import Loading from '../../../react/core/Loading'
import JobPostingRow from './../../components/JobPostingRow'

const generateJobPostingUrl = (landingPageIdentifier, jobPostingIdentifier) => `/landing/${landingPageIdentifier}/${jobPostingIdentifier}`

/**
 * Renders a list of jobs for a given landing page.
 * @param {object} landingPage The landing page to load jobs for.
 * @param {boolean} openInNewTab whether the job postings should be loaded on a new tab or on the same browsing context.
 * @returns {JSX.Element}
 */
export default function JobList ({ landingPage, openInNewTab }) {
  const { data: jobs, isError, isLoading } = useGetLandingPageJobsQuery({ landingPageIdentifier: landingPage.identifier, limit: 0 })

  if (isError) {
    return <ErrorLoading />
  }

  if (isLoading) {
    return <Loading />
  }

  return (
    <Paper pl='40px' pr='40px'>
      <Stack>
        {
          jobs.items.length !== 0
            ? jobs.items.map(job => (
                <JobPostingRow
                  key={job.identifier}
                  job={job}
                  color={landingPage.button_background_color}
                  to={openInNewTab ? generateJobPostingUrl(landingPage.identifier, job.identifier) : job.identifier}
                  openInNewTab={openInNewTab}
                />
            ))
            : <Text size='lg'>Currently there are no new job openings. Please check back again.</Text>
        }
      </Stack>
    </Paper>
  )
}
